import PropTypes from "prop-types";
import { memo } from "react";

// Components
import AddAction from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/AddAction";
import Arithmetic from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/Arithmetic";
import Chargebacks from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/Chargebacks";
import Delete from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/Delete";
import Expand from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/Expand";
import Filter from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/Filter";
import CustomAction from "@Layouts/components/Tables/DataSmartTable/toolbar/Actions/CustomAction";
import { QuickFilter } from "@Layouts/components/Tables/DataSmartTable/toolbar/SearchToolbar/QuickFilter";

import ConfirmToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/ConfirmToolbar";
import SearchToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/SearchToolbar";

// MUI
import { Box } from "@mui/material";

// Memos
const MemoAdd = memo(AddAction);
const MemoArithmetic = memo(Arithmetic);
const MemoChargeBack = memo(Chargebacks);
const MemoConfirm = memo(ConfirmToolbar);
const MemoDelete = memo(Delete);
const MemoExpand = memo(Expand);
const MemoFilter = memo(Filter);
const MemoSearch = memo(SearchToolbar);
const MemoCustomAction = memo(CustomAction);

function FirstActions(props) {
	const { apiRef, confirm, filter, search } = props;
	return (
		<>
			{!confirm?.hide && <MemoConfirm {...confirm} apiRef={apiRef} />}
			{!search?.hide &&
				(search.useQuickFilter ? (
					<QuickFilter initiallyOpened={search.initiallyOpened} disabled={search.disabled} />
				) : (
					<MemoSearch {...search} apiRef={apiRef} />
				))}
			{!filter?.hide && <MemoFilter {...filter} apiRef={apiRef} />}
		</>
	);
}
FirstActions.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	confirm: PropTypes.object,
	filter: PropTypes.object,
	search: PropTypes.object,
};

function MiddleActions(props) {
	const { apiRef, arithmetic, chargeBack } = props;
	return (
		<>
			{chargeBack && !chargeBack?.hide && <MemoChargeBack {...chargeBack} apiRef={apiRef} />}
			{arithmetic && !arithmetic?.hide && <MemoArithmetic {...arithmetic} apiRef={apiRef} />}
		</>
	);
}
MiddleActions.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	arithmetic: PropTypes.object,
	chargeBack: PropTypes.object,
};

function LastActions(props) {
	const { apiRef, add, deleteProperties, expand } = props;
	return (
		<>
			{!deleteProperties?.hide && <MemoDelete {...deleteProperties} apiRef={apiRef} />}
			{!expand?.hide && <MemoExpand {...expand} apiRef={apiRef} />}
			{!add?.hide && <MemoAdd {...add} apiRef={apiRef} />}
		</>
	);
}
LastActions.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	add: PropTypes.object,
	deleteProperties: PropTypes.object,
	expand: PropTypes.object,
};

function CustomActions(props) {
	const { apiRef, customAction } = props;
	return <>{!customAction?.hide && <MemoCustomAction {...customAction} apiRef={apiRef} />}</>;
}

CustomActions.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	customAction: PropTypes.object,
};

function ActionsToolbar(props) {
	const {
		apiRef,
		sxActions,
		add = {
			onAddAction: () => {},
			disabled: false,
			hide: true,
		},
		arithmetic,
		confirm = {
			hide: true,
			disabled: false,
			icon: null,
			iconConfirm: null,
			textConfirm: "",
			classes: "",
			mainClasses: "",
			textClasses: "",
			confirmTop: "",
			onConfirmAction: () => {},
		},
		chargeBack,
		deleteProperties = {
			onDeleteAction: () => {},
			disabled: false,
			hide: true,
		},
		expand = {
			onExpandAction: () => {},
			disabled: false,
			hide: true,
			columnsCollapsible: [],
		},
		filter = {
			disabled: false,
			hide: true,
		},
		search = {
			apiRef: { current: null },
			data: [],
			searchValue: "",
			disabled: false,
			parents: false,
			noEmptyParents: false,
			hide: true,
			nested: false,
			nodeExpandedIds: [],
			excludeKeys: ["_id", "id"],
			searchInNestedArrays: [],
			setNodeExpandedIds: () => {},
			onChange: () => {},
		},
		customAction = {
			hide: true,
			disabled: false,
		},
	} = props;
	return (
		<Box className="toolbar-actions" sx={{ ...sxActions, display: "flex" }}>
			<FirstActions apiRef={apiRef} confirm={confirm} filter={filter} search={search} />
			<MiddleActions apiRef={apiRef} arithmetic={arithmetic} chargeBack={chargeBack} />
			<LastActions apiRef={apiRef} add={add} deleteProperties={deleteProperties} expand={expand} />
			<CustomActions apiRef={apiRef} customAction={customAction} />
		</Box>
	);
}

ActionsToolbar.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	sxActions: PropTypes.object,
	add: PropTypes.object,
	arithmetic: PropTypes.object,
	confirm: PropTypes.object,
	chargeBack: PropTypes.object,
	deleteProperties: PropTypes.object,
	expand: PropTypes.object,
	filter: PropTypes.object,
	search: PropTypes.object,
	customAction: PropTypes.object,
};

export default ActionsToolbar;
